// static/src/scripts/index.js
import {initializeMenu} from "./menu.js"
import {API_PATH} from "./global_settings.js"

// Проверка авторизации при загрузке
window.onload = async function ()
{
    const token = localStorage.getItem("token")
    if (token)
    {
        const menuInitialized = await initializeMenu()
        if (menuInitialized)
        {
            await loadDashboard()
        }
    }

    const form = document.getElementById("loginFormElement")
    if (form)
    {
        form.addEventListener("submit", login)
    }
}

async function login(event)
{
    event.preventDefault()

    const email = document.getElementById("email").value
    const password = document.getElementById("password").value
    const loginBtn = document.getElementById("loginBtn")
    const errorDiv = document.getElementById("loginError")

    loginBtn.textContent = "Вход..."
    loginBtn.disabled = true
    errorDiv.style.display = "none"

    try
    {
        const response = await fetch(`${API_PATH}/login`, {
            method: "POST", headers: {
                "Content-Type": "application/json"
            }, body: JSON.stringify({email, password})
        })

        const data = await response.json()

        if (response.ok)
        {
            localStorage.setItem("token", data.access_token)
            await initializeMenu()
            await loadDashboard()
        }
        else
        {
            errorDiv.textContent = data.detail || "Ошибка авторизации"
            errorDiv.style.display = "block"
        }
    }
    catch (error)
    {
        errorDiv.textContent = "Ошибка соединения с сервером"
        errorDiv.style.display = "block"
    }

    loginBtn.textContent = "Войти"
    loginBtn.disabled = false
}

async function loadModulePicture(moduleId)
{
    const token = localStorage.getItem("token")
    try
    {
        console.log(`Загружаем картинку для модуля ${moduleId}`)
        const response = await fetch(`${API_PATH}/modules/${moduleId}/picture`, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })

        if (response.ok)
        {
            const data = await response.json()
            console.log(`Картинка для модуля ${moduleId} загружена успешно`)
            return data.picture
        }
        else
        {
            console.log(`Картинка для модуля ${moduleId} не найдена (${response.status})`)
        }
    }
    catch (error)
    {
        console.error(`Ошибка загрузки картинки для модуля ${moduleId}:`, error)
    }
    return null
}

async function loadDashboard()
{
    const token = localStorage.getItem("token")

    try
    {
        const response = await fetch(`${API_PATH}/me`, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })

        const userData = await response.json()

        if (response.ok)
        {
            document.getElementById("loginForm").style.display = "none"
            document.getElementById("dashboard").style.display = "block"

            // Отобразить модули
            const modulesDiv = document.getElementById("modules")
            modulesDiv.innerHTML = ""

            if (userData.modules.length === 0)
            {
                modulesDiv.innerHTML = "<p style=\"color: #666; text-align: center; padding: 20px;\">У вас нет доступа к модулям. Обратитесь к администратору.</p>"
            }
            else
            {
                // Создаем карточки модулей
                for (const module of userData.modules)
                {
                    const moduleCard = document.createElement("div")
                    moduleCard.className = "module-card"

                    const moduleUrl = module.url

                    // Загружаем картинку для модуля
                    const picture = await loadModulePicture(module.id)

                    // Создаем HTML с проверкой наличия картинки
                    if (picture)
                    {
                        moduleCard.innerHTML = `
                            <div class="module-image" style="background-image: url('${picture}')"></div>
                            <div class="module-overlay">
                                <div class="module-content">
                                    <div class="module-name">${module.title}</div>
                                    <div class="module-description">${module.description}</div>
                                </div>
                            </div>
                        `
                    }
                    else
                    {
                        // Если нет картинки, используем градиентный фон
                        moduleCard.innerHTML = `
                            <div class="module-image module-no-image"></div>
                            <div class="module-overlay">
                                <div class="module-content">
                                    <div class="module-name">${module.title}</div>
                                    <div class="module-description">${module.description}</div>
                                </div>
                            </div>
                        `
                    }

                    // Добавляем обработчик клика
                    moduleCard.addEventListener("click", () =>
                    {
                        if (moduleUrl !== "")
                        {
                            window.location.href = moduleUrl
                        }
                    })

                    if (moduleUrl === "")
                    {
                        moduleCard.classList.add("module-disabled")
                        moduleCard.title = "Модуль находится в разработке"
                    }

                    modulesDiv.appendChild(moduleCard)
                }
            }
        }
    }
    catch (error)
    {
        console.error("Ошибка загрузки дашборда:", error)
    }
}